"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get IntegrationEmployeeMapping () {
        return IntegrationEmployeeMapping;
    },
    get IntegrationEmployeeRecordMapping () {
        return IntegrationEmployeeRecordMapping;
    },
    get IntegrationEmployeeRecordMappingSettings () {
        return IntegrationEmployeeRecordMappingSettings;
    },
    get IntegrationEmployeeRecordMappingType () {
        return IntegrationEmployeeRecordMappingType;
    }
});
const _zod = require("zod");
const IntegrationEmployeeRecordMapping = _zod.z.enum([
    "employment",
    "compensation"
]);
const IntegrationEmployeeRecordMappingType = _zod.z.enum([
    "automatic",
    "manual"
]);
const IntegrationEmployeeMapping = _zod.z.object({
    /** Employee's first name for display purposes */ first_name: _zod.z.string(),
    /** Employee's last name for display purposes */ last_name: _zod.z.string(),
    /** Employee's email for identification */ email: _zod.z.string(),
    /** External employee ID from the source system (e.g., UKG employee ID) */ external_id: _zod.z.string(),
    /** Available record options for this employee */ options: _zod.z.array(_zod.z.object({
        /**
			 * Unique identifier for this record. It is a composite key that's should be composed
			 * of fields that identify the record uniquely.
			 */ record_id: _zod.z.string(),
        /**
			 * Display metadata varies by record type:
			 * - Employment: status, job_title, hire_date
			 * - Compensation: salary, currency, effective_date
			 */ display_metadata: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional()
    })),
    /** The selected record ID (if manually chosen). Composite key that's found in the options array. */ selected_record_id: _zod.z.string().nullish(),
    /** Stems from the integration worker document. Used to filter out records that aren't relevant to the customer. */ is_integration_worker_ignored: _zod.z.boolean()
});
const IntegrationEmployeeRecordMappingSettings = _zod.z.object({
    /**
	 * Record of mapping configurations by record type. Keys are record type identifiers
	 * (e.g., "employment", "compensation") and values contain the mapping configuration.
	 */ record_mappings: _zod.z.record(IntegrationEmployeeRecordMapping, _zod.z.object({
        /**
			 * How records are selected:
			 * - "automatic": System selects based on predefined criteria
			 * - "manual": Admin explicitly selects which record to use
			 */ mapping_type: IntegrationEmployeeRecordMappingType,
        /** Employee mapping entries with their available options and selections */ mapping_data: _zod.z.array(IntegrationEmployeeMapping)
    }))
});
